import PopupComponent, { IPopupProps } from '@components/std-components/Popup'
import React, { FC, useState } from 'react'
import { SelectComponent, SelectComponentProps } from '../SelectComponent'
import * as css from './SelectPopup.css'

export interface SelectPopupProps
  extends Pick<IPopupProps, 'trigger' | 'contentStyle' | 'position'>,
    SelectComponentProps {
  closeOnSelect?: boolean
}

export const SelectPopup: FC<SelectPopupProps> = ({
  trigger,
  contentStyle,
  position,
  closeOnSelect,
  ...selectComponentProps
}) => {
  const [open, setOpen] = useState(false)
  return (
    <PopupComponent
      trigger={<div onClick={() => setOpen(true)}>{trigger}</div>}
      className={css['select-popup-container']}
      nested={true}
      position={position || 'bottom left'}
      open={open}
      onOpen={() => setOpen(true)}
      contentStyle={{
        ...contentStyle,
        zIndex: 3000
      }}
      disabled={selectComponentProps.disabled}
      onClose={() => setOpen(false)}
    >
      <SelectComponent
        {...{
          ...selectComponentProps,
          ...(closeOnSelect
            ? {
                onSelect: (...args) => {
                  setOpen(false)
                  selectComponentProps?.onSelect?.(...args)
                }
              }
            : {})
        }}
      />
    </PopupComponent>
  )
}
